
import { Component } from '@niknevis/vue-modules'
import AdminDepositBankAccountBaseForm
  from '@/modules/deposit-bank-account/components/admin/base/AdminDepositBankAccountBaseForm.vue'
import {
  AdminUpdateDepositBankAccountUseCase
} from '@/modules/deposit-bank-account/use-cases/admin/admin-update-deposit-bank-account.use-case'
import { Prop } from 'vue-property-decorator'
import {
  DepositBankAccountResourceModel
} from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'
import {
  DepositBankAccountRequestModel
} from '@/modules/deposit-bank-account/models/deposit-bank-account-request.model'

@Component
export default class AdminDepositBankAccountCreateForm extends AdminDepositBankAccountBaseForm {
  constructor(
    private readonly useCase: AdminUpdateDepositBankAccountUseCase
  ) {
    super()
  }

  @Prop({ required: true }) depositBankAccountResource: DepositBankAccountResourceModel

  protected requestData: DepositBankAccountRequestModel = {
    account_number: this.depositBankAccountResource.account_number,
    account_owner_name: this.depositBankAccountResource.account_owner_name,
    account_type: this.depositBankAccountResource.account_type,
    card_number: this.depositBankAccountResource.card_number,
    default: this.depositBankAccountResource.default,
    sheba: this.depositBankAccountResource.sheba,
    status: this.depositBankAccountResource.status,
    title: this.depositBankAccountResource.title
  }

  protected onSubmit() {
    this.useCase.execute(this.depositBankAccountResource.id, this.requestData)
      .onSuccess(() => {
        this.$emit('success')
      })
  }
}
